import React, { useContext, useMemo } from 'react';
import {
	Wrapper,
	Container,
	TableContainer,
	AnalysisDescription,
} from './DetailedAnalysis.styles';
import { defaultGridHeight } from './utils';
import { CategorySpendBenchmarkContext } from 'contexts/CategorySpendBenchmark';
import AgGridTable from 'components/AGGridTable/AgGridTable';

const SpendAboveBenchmarkExplore = () => {
	const { gridData } = useContext(CategorySpendBenchmarkContext);
	const gridStyle = useMemo(() => defaultGridHeight, []);

	return (
		<Wrapper>
			<Container>
				<AnalysisDescription>
					{`List of categories with spend greater than median benchmarks (category spend as % of total indirect spend).`}
				</AnalysisDescription>
				<TableContainer>
					<AgGridTable gridOptions={gridData} gridStyle={gridStyle} />
				</TableContainer>
			</Container>
		</Wrapper>
	);
};

export default SpendAboveBenchmarkExplore;
